import * as TYPES from '../types';

const initialState = {
    researchList: [],
};

export function ResearchReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_RESEARCH_SUCCESS:
            return {
                ...preState,
                researchList: payload,
            };

        default:
            return state;
    }
}